import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

let configured = false;

/**
 * Only the autocomplete/GPS hooks load through here — the map itself is bootstrapped by vis.gl's
 * `APIProvider`. The two coexist: `setOptions` detects an existing `google.maps.importLibrary`
 * (whichever side got there first) and reuses it instead of injecting a second script.
 */
const ensureConfigured = () => {
  if (configured) return;
  setOptions({ key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? "", v: "weekly" });
  configured = true;
};

export const loadPlacesLibrary = () => {
  ensureConfigured();
  return importLibrary("places");
};

export const loadGeocodingLibrary = () => {
  ensureConfigured();
  return importLibrary("geocoding");
};
